import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';
import {
    WIDTH_OF_EACH_TILE,
    RIGHT_PADDING_OF_EACH_TILE,
    MAX_CONTENT_TO_SHOW_INITIALLY_OPX,
    getMaxInsightsToShowOnInitialRender,
} from 'owa-meeting-insights/lib/selectors/meetingInsightsConsts';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export function getInsightsToRenderBasedOnContainerWidth(
    widthOfContainer: number,
    insightsEntrySource: InsightsDataFetchSource
): number {
    if (widthOfContainer == -1) {
        // If width is -1, this is initial load, so we don't know the width
        return getMaxInsightsToShowOnInitialRender(insightsEntrySource);
    }

    // Calculate # of insights to show depending on size
    const insightsCount = Math.floor(
        (widthOfContainer + RIGHT_PADDING_OF_EACH_TILE) /
            (WIDTH_OF_EACH_TILE + RIGHT_PADDING_OF_EACH_TILE)
    );

    if (isHostAppFeatureEnabled('showMinimumThreeInsights')) {
        // If OPX scenario, then we load 3 tiles at a minimum
        return Math.max(MAX_CONTENT_TO_SHOW_INITIALLY_OPX, insightsCount);
    }

    return insightsCount;
}

export function getSeeMoreButtonRightMargin(widthOfContainer: number, tileCount: number) {
    const contentWidth = tileCount * (WIDTH_OF_EACH_TILE + RIGHT_PADDING_OF_EACH_TILE);
    const visibleContentWidth = contentWidth - RIGHT_PADDING_OF_EACH_TILE;

    return Math.max(widthOfContainer - visibleContentWidth, 0);
}
